import buildChildURL from './build-child-url';

export default (...names: string[]) => `/${buildChildURL(...names)}`;
